import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    maxWidth: 1280,
    padding: `${theme.spacing(10)}px ${theme.spacing(3)}px`,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(10)}px ${theme.spacing(1)}px`,
    },
  },
  content: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  square: {
    width: '100%',
    paddingBottom: '100%',
  },
  card: {
    width: 'min(100%, 365px)',
    height: 'max(100%, 365px)',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '0.8rem',
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
      height: '90vw',
      margin: '0 auto',
    },
  },
  block: {
    minHeight: 400,
    maxWidth: '70%',
    flex: '1 1',
    [theme.breakpoints.down('sm')]: {
      minHeight: 'unset',
      width: '100%',
      maxWidth: 'unset',
    },
    padding: `${theme.spacing(3)}px ${theme.spacing(8)}`,
  },
  image: {
    width: '40%',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  info: {
    textAlign: 'left',
  },
  cakeName: {
    ...theme.typography.h2PurpleText,
    textAlign: 'inherit',
  },
  price: {
    ...theme.typography.titlePurpleText,
    color: theme.palette.gray,
    textAlign: 'inherit',
    '& span': {
      fontWeight: 400,
    },
  },
  cakeInfo: {
    ...theme.typography.normalGrayText,
    display: 'flex',
    textAlign: 'inherit',
    '& span': {
      marginRight: theme.spacing(2),
      display: 'flex',
      '& svg': {
        marginRight: theme.spacing(1),
      },
    },
  },
  recipe: {
    ...theme.typography.normalGrayText,
    maxWidth: 440,
  },
  buy: {
    ...theme.actionLinkButton,
    ...theme.buttonOutline,
    ...theme.typography.normalWhiteText,
    backgroundColor: theme.palette.purple,
    transition: 'background-color 0.25s',
    [theme.breakpoints.up('md')]: {
      '&:hover': {
        transform: 'unset',
        backgroundColor: theme.palette.purpleDarker,
      },
    },
  },
  popular: {
    marginTop: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, 167px)',
    gridAutoRows: 167,
    gridRowGap: '2rem',
    justifyContent: 'space-between',
  },
  popularLink: {
    ...theme.buttonOutline,
    borderRadius: '0.8rem',
    overflow: 'hidden',
    '& img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  },
  titlePopular: {
    ...theme.typography.titlePurpleText,
    textAlign: 'left',
  },
}));
